"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var convertVideoAttributesToReactProps = function (videoAttributes) {
    if (videoAttributes) {
        var autoPlay = videoAttributes.autoPlay, controls = videoAttributes.controls, height = videoAttributes.height, width = videoAttributes.width, muted = videoAttributes.muted, loop = videoAttributes.loop;
        var attributes = {
            autoPlay: autoPlay,
            controls: controls,
            muted: muted,
            loop: loop
        };
        if (height !== undefined && height >= 0) {
            attributes.height = height;
        }
        if (width !== undefined && width >= 0) {
            attributes.width = width;
        }
        return attributes;
    }
    return {};
};
var Video = function (_a) {
    var styles = _a.styles, src = _a.src, videoAttributes = _a.videoAttributes;
    return src ? (react_1.default.createElement("video", __assign({ src: src, style: styles }, convertVideoAttributesToReactProps(videoAttributes)))) : (react_1.default.createElement(react_1.Fragment, null));
};
exports.default = Video;
//# sourceMappingURL=Video.js.map